// web/src/firebase.ts
//
// Firebase client initialisation. The project this app talks to is NOT written
// here — it comes from build-time Vite env vars via config/appConfig.ts, chosen
// by `--mode` (web/.env.<mode>). Until 2026-08-10 the config below was a
// literal object naming the main project, so any fork built from this source
// talked to main instead of itself.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { firebaseConfig } from './config/appConfig';

// Initialize Firebase
const app = initializeApp(firebaseConfig());

// Initialize services — both prod and dev use the same Firestore (default) database
// so Cloud Functions and frontend stay in sync
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to Emulators if running locally
// if (window.location.hostname === 'localhost') {
//   console.log('🔧 Connecting to Firebase Emulators');
//   const { connectAuthEmulator } = require('firebase/auth');
//   const { connectFirestoreEmulator } = require('firebase/firestore');
//   const { connectOutputEmulator } = require('firebase/storage'); // No emulator for storage? connectStorageEmulator exists
//   const { connectFunctionsEmulator } = require('firebase/functions');
//   
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   // connectStorageEmulator(storage, 'localhost', 9199);
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

export default app;